import styles from './index.module.less';
import DeliveryTime from '@base/snippets/DeliveryTime';
import { IVariant } from 'base/interfaces/product';

type IProps = {
    shownVariant: IVariant
}

export const DeliveryTip: React.FC<IProps> = props => {
    const {
        shownVariant: {
            deliveryTime
        },
    } = props;

    return <div className={styles['delivery-wrap']}>
        <DeliveryTime deliveryTime={deliveryTime} className={styles['delivery']}/>
    </div>

}